__turbopack_context__.v({
  "article": "loading-module__Pp_nCa__article",
  "hero": "loading-module__Pp_nCa__hero",
  "heroContent": "loading-module__Pp_nCa__heroContent",
  "heroImage": "loading-module__Pp_nCa__heroImage",
  "metaRow": "loading-module__Pp_nCa__metaRow",
  "sidebar": "loading-module__Pp_nCa__sidebar",
  "steps": "loading-module__Pp_nCa__steps",
  "twoCol": "loading-module__Pp_nCa__twoCol",
  "variantSkeletonRow": "loading-module__Pp_nCa__variantSkeletonRow",
  "variantSkeletonTab": "loading-module__Pp_nCa__variantSkeletonTab",
  "variantSkeletonWrapper": "loading-module__Pp_nCa__variantSkeletonWrapper",
});
